import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledTableContainer = styled.div`
  border: 2px solid rgb(238, 238, 238);
  overflow-x: scroll;
  width: 100%;
  position: relative;
  max-height: 600px;
  overflow: auto;
`;

export const StyledTable = styled.table<{ width: number; height?: number }>`
  border-collapse: separate;
  border-spacing: 0;
  text-align: center;
  width: ${({ width }): number => width}px;
  ${({ height }): string | undefined => (height ? `height: ${height}px` : undefined)}
`;

export const StyledTh = styled.th<{
  boxShadow: string | undefined;
  left: string | undefined;
  position: string;
  zIndex: number;
  width: number;
}>`
  width: ${({ width }): number => width}px;
  position: ${({ position }): string => position};
  z-index: ${({ zIndex }): number => zIndex};
  left: ${({ left }): string | undefined => left};
  box-shadow: ${({ boxShadow }): string | undefined => boxShadow};
  background-color: #ffffff;
  border: 1px solid rgb(238, 238, 238);
  font-weight: bold;
  padding: 6px 6px;
  text-align: center;
  height: 36px;
`;

export const StyledInnerTh = styled.div<{ cursor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: ${({ cursor }): string | undefined => (cursor ? cursor : 'default')};
  height: 54px;
`;

export const StyledTd = styled.td<{
  boxShadow: string | undefined;
  left: string | undefined;
  position: string;
  zIndex: number;
  width: number;
}>`
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 4px;
  text-align: center;
  width: ${({ width }): number => width}px;
  position: ${({ position }): string => position};
  z-index: ${({ zIndex }): number => zIndex};
  left: ${({ left }): string | undefined => left};
  box-shadow: ${({ boxShadow }): string | undefined => boxShadow};
`;

export const StyledInnerTd = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchInput = styled.input`
  text-align: center;
  border: 1px solid lightgrey;
  height: 40px;
  border-radius: 2px;
`;

export const StyledTr = styled.tr`
  height: 40px;

  td {
    height: 40px;
  }

  :nth-child(odd) {
    td {
      background-color: #f9f9f9;
    }
  }

  :nth-child(even) {
    td {
      background-color: #fff;
    }
  }
`;

export const StyledVirtualizedTr = styled.tr<{ sticky?: boolean; translateY: number; width: number }>`
  width: ${(props): number => props.width}px;
  height: 40px;
  position: absolute;
  top: 0;
  left: 0;
  transform: ${(props): string => `translateY(${props.translateY}px)`};
  td {
    height: 40px;
  }

  :nth-child(odd) {
    td {
      background-color: #f9f9f9;
    }
  }

  :nth-child(even) {
    td {
      background-color: #fff;
    }
  }
`;

export const StyledThead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 2;
`;
